export default class ButtonHover {
  constructor() {
    this.getDomElements()

    if (!this.dom.buttons.length) return
    
    this.init()
  }

  init() {
    this.buttons = []

    this.dom.buttons.forEach(button => {
      const cursor = button.querySelector('.js-button-cursor')
      
      if (!button || !cursor) return
      
      button.addEventListener('mousemove', function(e) {
        const offset = 100; // offset around button
        const rect = button.getBoundingClientRect();
    
        const newX = e.offsetX;
        const newY = e.offsetY;
    
        if(newX < -offset || newX > (rect.width + offset)) {
          cursor.style.opacity = 0;
          return
        }
    
        const x = e.offsetX
    
        if(newY < -offset || newY > (rect.height + offset)) {
          cursor.style.opacity = 0
          return
        }
    
        const y = e.offsetY
    
        cursor.style.left = `${x-85}px`
        cursor.style.top = `${y-85}px`
      })
    })
  }

  getDomElements() {
    this.dom = {
      'buttons' : document.querySelectorAll('.js-button')
    }
  }
}